import React, { useState, useEffect } from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import * as CONSTANTS from 'Utils/constants';
import payMoreDollar from 'Assets/png/payg_pricing/pay-more-dollar.png';
import cvvImg from 'Assets/png/payg_pricing/cvv.png';
import transactionSuccess from 'Assets/png/payg_pricing/transaction-success.png';
import transactionFailed from 'Assets/png/payg_pricing/transaction-failed.png';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon-new.svg';
import { ReactComponent as ArrowIcon } from 'Assets/svg/right-arrow.svg';
import { HocPopupComponent } from 'Components/common/hocPopupComponent';
import { loginValidate } from 'Utils/commonApi';
import { Utils } from 'Utils/utils';
import { URLS, makeApi } from 'Utils/apiUtil';
import Button from './Button';
import 'Styles/popup/_paygPurchaseMorePopup.scss';
import StripeCVVCheck from './StripeCVVCheck';

const { MX_PAYG_PRICING_EVENT } = CONSTANTS;

const {
  LB_PAYG_BUY_CTA_CLICK,
  LB_PAYG_CVV_SCREEN_VIEWED,
  LB_PAYG_CVV_VALIDATION_CLICK,
  LB_PAYG_PAYMENT_STATUS_SCREEN_VIEWED,
} = MX_PAYG_PRICING_EVENT;
class PaygPurchaseMorePopupState {
  @observable showPopup = null;

  defaultPopupValue = {
    numberOfCreditsRequired: 0,
    amount: 0,
    isMinimumPurchase: false,
    callback() {
      console.log('callback');
    },
  };

  CURRENT_STEPS = {
    REQUIRED_CREDITS_SCREEN: 'REQUIRED_CREDITS_SCREEN',
    CVV_SCREEN: 'CVV_SCREEN',
    SUCCESS_SCREEN: 'SUCCESS_SCREEN',
    FAILED_SCREEN: 'FAILED_SCREEN',
  };

  @observable popupValues = this.defaultPopupValue;

  @observable intermediateId = null;

  @observable paygCheckLoader = false;

  @observable extraCreditsPaymentDetailLoading = false;

  @observable extraCreditCardDetail = {};

  @action
  setPaygCheckLoader = val => {
    this.paygCheckLoader = val;
  };

  @action
  setIntermediateId = val => {
    this.intermediateId = val;
  };

  @action
  setShowPopup = val => {
    this.showPopup = val;
  };

  @action
  setPopupValues = val => {
    this.popupValues = val;
  };

  // eslint-disable-next-line consistent-return
  getExtraCreditsPaymentDetail = async (emailCredits, phoneCredits) => {
    this.extraCreditsPaymentDetailLoading = true;
    const url = Utils.generateUrl(URLS?.getExtraCreditsPaymentDetail, {
      credits: emailCredits,
      phoneCredits,
    });
    this.extraCreditCardDetail = {};
    const pricingConfig = {
      url,
    };
    let resStatus = false;
    const response = await makeApi(pricingConfig);
    if (response && response.data) {
      const { responseCode = null } = response.data;
      if (responseCode && responseCode === 200) {
        const { intermediateId } = response.data;
        if (intermediateId) this.setIntermediateId(intermediateId);
        this.extraCreditCardDetail = response.data;
        resStatus = true;
      }
    }
    this.extraCreditsPaymentDetailLoading = false;
    return resStatus;
  };

  buyAdditionalCredits = async (data = {}) => {
    try {
      const paymentConfig = {
        url: URLS?.buyAdditionalCredits,
        method: 'POST',
        data,
      };
      const response = await makeApi(paymentConfig);
      return response;
    } catch (e) {
      console.log('get card details', e);

      return null;
    }
  };

  updateBuyAdditionalCreditFailed = async (data = {}) => {
    try {
      const paymentConfig = {
        url: URLS?.updateBuyAdditionalCreditFailed,
        method: 'POST',
        data,
      };
      const response = await makeApi(paymentConfig);
      return response;
    } catch (e) {
      console.log('get card details', e);

      return null;
    }
  };
}
const paygPurchaseMorePopupState = new PaygPurchaseMorePopupState();

const CreditDetailsScreen = observer(props => {
  const {
    popupValues = {},
    cardDetailsLoading,
    getCardDetails = () => {},
  } = props;
  const { numberOfCreditsRequired, amount, isMinimumPurchase } = popupValues;

  const getPaymentInfo = () => {
    Utils.mixpanelTrack(LB_PAYG_BUY_CTA_CLICK, {});
    getCardDetails(2);
  };

  const btnText = () => (
    <span>
      Buy {Utils.viewsDownloadsNumberFormat(numberOfCreditsRequired)} credits
      for ${Utils.viewsDownloadsNumberFormat(amount)}
    </span>
  );
  return (
    <div className="credit-details-screen">
      <img src={payMoreDollar} alt="payMoreDollar" />
      <div className="title">Oops! </div>
      {isMinimumPurchase ? (
        <div className="description">
          Purchase additional credits to continue your prospecting. Our minimum
          pack starts from ${Utils.viewsDownloadsNumberFormat(amount)} where you
          get {Utils.viewsDownloadsNumberFormat(numberOfCreditsRequired)}{' '}
          credits.
        </div>
      ) : (
        <div className="description">
          You have run out of credits. You need to purchase an additional{' '}
          {Utils.viewsDownloadsNumberFormat(numberOfCreditsRequired)} credits to
          complete this transaction.
        </div>
      )}
      <Button
        isHtmlBtnContent
        HtmlBtnContent={btnText}
        icon={false}
        iconName=""
        type="button"
        className={`action-btn ${cardDetailsLoading ? ' loading' : ''}`}
        loader={cardDetailsLoading}
        click={e => getPaymentInfo(e)}
      />
    </div>
  );
});

const AlternatePaymentBtn = props => {
  const { popupValues = {}, btnText, btnType } = props;
  const { isBuyMoreCreditsPage = false } = popupValues;

  const handleClick = () => {
    paygPurchaseMorePopupState.setShowPopup(null);

    if (isBuyMoreCreditsPage) Utils.redirectToManageBillingPage();
    else Utils.openManageBillingPage();
  };
  return (
    <Button
      btnText={btnText}
      icon={false}
      iconName=""
      type="button"
      className={`action-btn ${btnType === 'link' ? ' link-style' : ''}`}
      svg={<ArrowIcon className="arrow-right" width={14} height={18} />}
      click={e => handleClick(e)}
    />
  );
};

const CvvVerificationScreen = props => {
  const { popupValues = {}, cardDetailsInfo, callback = () => {} } = props;
  const { amount } = popupValues;
  const { cardLastFourDigit, clientSecret, paymentMethodId } = cardDetailsInfo;

  const cvvCheckCallback = (response, error) => {
    callback(response, error);
  };
  const btnText = () => (
    <span>
      Complete ${Utils.viewsDownloadsNumberFormat(amount)} Transaction
    </span>
  );
  useEffect(() => {
    Utils.mixpanelTrack(LB_PAYG_CVV_SCREEN_VIEWED, {});
  }, []);

  return (
    <div className="credit-details-screen">
      <img src={cvvImg} alt="cvvImg" />
      <div className="title">Enter your CVV to continue</div>
      <div className="card-details-section">
        <div className="card-number-section">
          <div className="card-number masked-card-number">****</div>
          <div className="card-number-seperator">-</div>
          <div className="card-number masked-card-number">****</div>
          <div className="card-number-seperator">-</div>
          <div className="card-number masked-card-number">****</div>
          <div className="card-number-seperator">-</div>
          <div className="card-number">{cardLastFourDigit}</div>
          <div className="card-number">
            <TickIcon className="tick-icon" />
          </div>
        </div>
        <div className="cvv-form-section">
          <StripeCVVCheck
            callback={cvvCheckCallback}
            clientSecret={clientSecret}
            paymentMethodId={paymentMethodId}
            btnText={`Complete $${amount} Transaction`}
            isHtmlBtnContent
            HtmlBtnContent={btnText}
          />
        </div>
      </div>
      <AlternatePaymentBtn
        btnText="Update your credit card details"
        btnType="link"
        {...props}
      />
    </div>
  );
};

const PaymentSuccessScreen = props => {
  const { popupValues = {}, successDetail } = props;
  const { isBuyMoreCreditsPage = false } = popupValues;
  const { amountPaid, creditsAdded, phoneCreditsAdded } = successDetail;

  const { callback } = popupValues;
  const continueClick = () => {
    paygPurchaseMorePopupState.setShowPopup(null);
    if (callback) callback();
  };
  useEffect(() => {
    Utils.mixpanelTrack(LB_PAYG_PAYMENT_STATUS_SCREEN_VIEWED, {
      'Payment Status': 'Success',
      'Additional Credits': creditsAdded,
      Amount: amountPaid,
    });
  }, []);
  return (
    <div className="credit-details-screen success-screen">
      <img src={transactionSuccess} alt="transactionSuccess" />
      <div className="title">Your transaction is successful!</div>
      <div className="description">
        <div className="desc-items">
          Amount Paid: ${Utils.viewsDownloadsNumberFormat(amountPaid)}
        </div>
        <div className="desc-items">
          Email Credits Purchased: {Utils.viewsDownloadsNumberFormat(creditsAdded)}
        </div>
        <div className="desc-items">
          Phone Credits Purchased: {Utils.viewsDownloadsNumberFormat(phoneCreditsAdded)}
        </div>
      </div>
      <Button
        btnText={isBuyMoreCreditsPage ? 'Start Prospecting!' : 'Continue'}
        icon={false}
        iconName=""
        type="button"
        className="action-btn"
        click={e => continueClick(e)}
      />
    </div>
  );
};

const PaymentFailedScreen = props => {
  const { popupValues = {} } = props;
  useEffect(() => {
    Utils.mixpanelTrack(LB_PAYG_PAYMENT_STATUS_SCREEN_VIEWED, {
      'Payment Status': 'Failure',
    });
  }, []);
  return (
    <div className="credit-details-screen failed-screen">
      <img src={transactionFailed} alt="transactionFailed" />
      <div className="title">We couldn’t process your payment!</div>
      <div className="description">
        Unfortunately, we couldn’t collect the payment for your purchase. Please
        take a moment to review and manage the payment information and then
        repeat the transaction again.
      </div>
      <AlternatePaymentBtn btnText="Manage Payment Methods" {...props} />
    </div>
  );
};

const PaygPurchaseMorePopup = observer(() => {
  const {
    showPopup,
    popupValues = {},
    CURRENT_STEPS,
    extraCreditsPaymentDetailLoading,
    extraCreditCardDetail,
  } = paygPurchaseMorePopupState;
  const { numberOfCreditsRequired } = popupValues;
  const {
    REQUIRED_CREDITS_SCREEN,
    CVV_SCREEN,
    SUCCESS_SCREEN,
    FAILED_SCREEN,
  } = CURRENT_STEPS;
  const [paymentSuccessDetail, setPaymentSuccessDetail] = useState(null);

  const closeClick = () => {
    paygPurchaseMorePopupState.setShowPopup(null);
  };

  const getCardDetails = async () => {
    try {
      if (!extraCreditsPaymentDetailLoading) {
        const response = await paygPurchaseMorePopupState.getExtraCreditsPaymentDetail(
          numberOfCreditsRequired,
        );

        if (response) paygPurchaseMorePopupState.setShowPopup(CVV_SCREEN);
        else paygPurchaseMorePopupState.setShowPopup(FAILED_SCREEN);
      }
    } catch (e) {
      console.log('get card details', e);
    }
  };

  const capturePayment = async (res, error) => {
    try {
      Utils.mixpanelTrack(LB_PAYG_CVV_VALIDATION_CLICK, {});
      if (res !== null) {
        const { id: paymentIndentId } = res;

        const response = await paygPurchaseMorePopupState.buyAdditionalCredits({
          paymentIndentId,
          intermediateId: paygPurchaseMorePopupState.intermediateId,
        });
        if (response && response.data) {
          const { responseCode = null } = response.data;
          if (responseCode && responseCode === 200) {
            const { amountPaid, creditsAdded, phoneCreditsAdded } = response.data;
            setPaymentSuccessDetail({ amountPaid, creditsAdded, phoneCreditsAdded });
            paygPurchaseMorePopupState.setShowPopup(SUCCESS_SCREEN);
            paygPurchaseMorePopupState.setIntermediateId(null);
            loginValidate();
          } else {
            paygPurchaseMorePopupState.setShowPopup(FAILED_SCREEN);
          }
        } else {
          paygPurchaseMorePopupState.setShowPopup(FAILED_SCREEN);
        }
      } else {
        const { declineCode, failedCode } = error;
        paygPurchaseMorePopupState.updateBuyAdditionalCreditFailed({
          declineCode,
          failedCode,
          intermediateId: paygPurchaseMorePopupState.intermediateId,
        });
        paygPurchaseMorePopupState.setShowPopup(FAILED_SCREEN);
      }
    } catch (e) {
      console.log('get card details', e);
    }
  };

  return showPopup !== null ? (
    <HocPopupComponent
      customClassName="payg-purchase-more-popup"
      customClassNameOnly="payg-purchase-more-popup-only"
      allowMaskClick
      closeClick={closeClick}
    >
      {showPopup === REQUIRED_CREDITS_SCREEN ? (
        <CreditDetailsScreen
          popupValues={popupValues}
          getCardDetails={getCardDetails}
          cardDetailsLoading={extraCreditsPaymentDetailLoading}
        />
      ) : showPopup === CVV_SCREEN ? (
        <CvvVerificationScreen
          popupValues={popupValues}
          cardDetailsInfo={extraCreditCardDetail}
          callback={capturePayment}
        />
      ) : showPopup === SUCCESS_SCREEN ? (
        <PaymentSuccessScreen
          popupValues={popupValues}
          successDetail={paymentSuccessDetail}
        />
      ) : showPopup === FAILED_SCREEN ? (
        <PaymentFailedScreen popupValues={popupValues} />
      ) : (
        ''
      )}
    </HocPopupComponent>
  ) : (
    ''
  );
});

export { paygPurchaseMorePopupState, PaygPurchaseMorePopup };
export default PaygPurchaseMorePopup;
